<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    console.log(`NODE_ENV: ${process.env?.NODE_ENV}`)
    console.log(`VUE_APP_ENV: ${process.env?.VUE_APP_ENV}`)
    console.log(`BASE_API: ${process.env?.BASE_API}`)
    console.log(`SERVER_DOMAIN: ${process.env?.SERVER_DOMAIN}`)
    console.log(`VUE_SERVER_DOMAIN: ${process.env?.VUE_SERVER_DOMAIN}`)
    console.log(`PACKAGE_VERSION: ${process.env?.PACKAGE_VERSION}`)
    console.log(`VUE_APP_BASE_API: ${process.env?.VUE_APP_BASE_API}`)
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css" ></style>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.tooltip-inner {
  max-width: 100%;
  text-align: left;
  background-color: #4f5055;
}

.multiselect__tag {
  color: #000;
  background-color: #E0E7F0;
}

.is-invalid input, .is-invalid svg {
  border-color: #dc3545 !important;
  color: #dc3545;
}

.is-invalid input:focus {
  outline-color: #dc3545 !important;
  box-shadow: 0 0 0 0.25rem rgb(220 53 69 / 25%);
}

.is-invalid .multiselect__tags {
  border-color: #dc3545 !important;
  color: #dc3545;
}

.is-invalid .multiselect__select:before {
  border-color: #dc3545 transparent transparent !important;
  color: #dc3545;
}
</style>
